module.exports = __webpack_public_path__ + "static/bill_small-e1038b5575b9857c90eb19294e902c1d.png";